<div class="container">
	<div class="role-selection">
		<h1>Choose Your Role to Get Started</h1>
		<p class="subheading">
			Select the role that best describes you to personalize your experience.
		</p>
		<div class="container pt-5">
			<div class="row">
				<div class=" col-md-6 role-cards">
					<div class="card mt-5" *ngFor="let user of users" [class.selected]="selectedRole === user.role"
						(click)="selectRole(user.role, user.role_id)" tabindex="0" role="button">
						<img [src]="user.image" [alt]="user.role" class="img-fluid img-role" />
						<h2 class="create-account">{{user.name}}</h2>
						<p>{{ user.para }}</p>
					</div>
				</div>
			</div>
		</div>
		<div class="mt-auto d-flex justify-content-end px-5 py-3">
			<button class="next-button" [disabled]="!selectedRole" (click)="postAssignRole()">NEXT →</button>
		</div>
	</div>
</div>
/
